import axios from "axios";
import { SERVER_URL } from "../config/config";

class PositionServices {
  private static serverURL = SERVER_URL;

  private static get axiosConfig() {
    return {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
  }

  public static async getPositions(sectionId?: number) {
    const apiUrl = `${this.serverURL}/api/position`;
    return axios.get(apiUrl, {
      ...this.axiosConfig,
      params: sectionId ? { sectionId } : {},
    });
  }

  public static async createPosition(body: { SectionId: number; Name: string }) {
    const apiUrl = `${this.serverURL}/api/position`;
    return axios.post(apiUrl, body, this.axiosConfig);
  }

  public static async updatePosition(id: number, body: { Name: string }) {
    const apiUrl = `${this.serverURL}/api/position/${id}`;
    return axios.put(apiUrl, body, this.axiosConfig);
  }

  public static async deletePosition(id: number) {
    const apiUrl = `${this.serverURL}/api/position/${id}`;
    return axios.delete(apiUrl, this.axiosConfig);
  }

  public static async getMemberPositions(memberId: number) {
    const apiUrl = `${this.serverURL}/api/position/member-positions`;
    return axios.get(apiUrl, {
      ...this.axiosConfig,
      params: { memberId },
    });
  }

  public static async assignMemberPosition(body: {
    MemberSectionId: number;
    PositionId: number;
  }) {
    const apiUrl = `${this.serverURL}/api/position/member-positions`;
    return axios.post(apiUrl, body, this.axiosConfig);
  }

  public static async removeMemberPosition(assignmentId: number) {
    const apiUrl = `${this.serverURL}/api/position/member-positions/${assignmentId}`;
    return axios.delete(apiUrl, this.axiosConfig);
  }
}

export default PositionServices;
